__turbopack_context__.v({
  "col": "content-module-scss-module__2bAKVG__col",
  "colTitle": "content-module-scss-module__2bAKVG__colTitle",
  "container": "content-module-scss-module__2bAKVG__container",
  "content": "content-module-scss-module__2bAKVG__content",
  "footerPanel": "content-module-scss-module__2bAKVG__footerPanel",
  "footerPanelArrow": "content-module-scss-module__2bAKVG__footerPanelArrow",
  "footerPanelContentWrapper": "content-module-scss-module__2bAKVG__footerPanelContentWrapper",
  "footerPanelGroup": "content-module-scss-module__2bAKVG__footerPanelGroup",
  "footerPanelHeader": "content-module-scss-module__2bAKVG__footerPanelHeader",
  "isSmall": "content-module-scss-module__2bAKVG__isSmall",
  "item": "content-module-scss-module__2bAKVG__item",
  "itemTextContainer": "content-module-scss-module__2bAKVG__itemTextContainer",
  "linksContainer": "content-module-scss-module__2bAKVG__linksContainer",
  "logo": "content-module-scss-module__2bAKVG__logo",
  "pageContainerWithStickyFooter": "content-module-scss-module__2bAKVG__pageContainerWithStickyFooter",
  "panelGroupHeaderArrowIcon": "content-module-scss-module__2bAKVG__panelGroupHeaderArrowIcon",
  "row": "content-module-scss-module__2bAKVG__row",
});
